export default __webpack_public_path__ + "static/media/pen.b1746e90.svg";